import { Stack } from '@ui-components/neo.tax';
import * as React from 'react';

import { useQuestionSections } from '@neo.tax/rd/hooks';
import { QuestionSectionCode } from '@neo.tax/shared';

import { RdLockPageLayout } from '../rd-lock-page-layout';
import { QuestionSection } from './QuestionSection';

export const CompanyInfo: React.FC = () => {
  const { questionSections, taxYear } = useQuestionSections();
  const visibleQuestionSections = questionSections.filter(
    (questionSection) =>
      questionSection.sectionCode !== QuestionSectionCode.CreditCalculation &&
      questionSection.sectionCode !== QuestionSectionCode.ShortYearDetails,
  );

  // We actually always have a `taxYear` by the time we get here, we just can't
  // prove it.
  if (!taxYear) {
    return <></>;
  }

  return (
    <RdLockPageLayout title="Company Information" subtitle="Fill out details about your company." fullWidth>
      <Stack gap={6} direction="column">
        {visibleQuestionSections.map((questionSection) => (
          <QuestionSection key={questionSection.id} questionSection={questionSection} taxYear={taxYear} />
        ))}
      </Stack>
    </RdLockPageLayout>
  );
};
